import { styled } from '@mui/system';
import { fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing } from '../../../../../ui/utils';
import { Gapper } from '../../../../../ui/utils';
import { SectionHeading, SectionSubtext } from '../../../../../ui/typography';

export const Wrapper = styled(Gapper)(({ theme }) => ({
  width: '100%',
  maxWidth: 1150,
  margin: '0 auto',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const Title = styled(SectionHeading)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(50, -1),
  textAlign: 'center',
  maxWidth: 900,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '44px',
    letterSpacing: figmaLetterSpacing(36, -1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: figmaLetterSpacing(28, -1),
  },
}));

export const Subtitle = styled(SectionSubtext)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 600,
  lineHeight: '32px',
  letterSpacing: figmaLetterSpacing(22, 2),
  textAlign: 'center',
  color: theme.palette.text.primary,
  maxWidth: 900,
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: figmaLetterSpacing(20, 2),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: figmaLetterSpacing(18, 2),
  },
}));

export const Text = styled(Subtitle)(({ theme }) => ({
  fontWeight: 400,
  maxWidth: 900,
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: figmaLetterSpacing(18, 2),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: figmaLetterSpacing(16, 2),
  },

  '& b': {
    fontWeight: 600,
  },
}));

export const ListTitle = styled(Subtitle)(({ theme }) => ({
  fontWeight: 700,
  maxWidth: '100%',
}));
